import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { consentStatusQuery } from "@/shared/edge/queries";
import { patientDomainIdFromProfile } from "@/shared/lib/patient-profile";

/** Nothing past this point until the patient has consented. */
export const Route = createFileRoute("/_consented")({
  beforeLoad: async ({ context, location }) => {
    const status = await context.queryClient.fetchQuery(
      consentStatusQuery(patientDomainIdFromProfile(context.profile)),
    );
    if (!status.hasConsented) throw redirect({ to: "/consent", search: { redirect: location.href } });
  },
  component: Outlet,
});
